module.exports = __webpack_public_path__ + "img/open-mail.35033d7d.svg";